"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var SvgFan = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 32px;\n  height: 32px;\n"], ["\n  width: 32px;\n  height: 32px;\n"])));
function SvgFanFilled(props) {
    return (React.createElement(SvgFan, null,
        React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
            React.createElement("path", { d: "M24.06 16l-1 1.73 4.31 2.49c-1.48 2.32-3 3.69-4.51 4.1a4.81 4.81 0 01-3.76-.72 4.62 4.62 0 01-2.63-3.6 3.85 3.85 0 001.27-.33 4 4 0 002.26-4.2 6.52 6.52 0 003.07-6 6.78 6.78 0 00-1.85-5C19.56 2.8 16.88 2 13 2h-1v7h2V4c2.74.12 4.69.74 5.8 1.85a4.86 4.86 0 011.26 3.62 4.62 4.62 0 01-1.84 4.09 3.89 3.89 0 00-1.82-1.34 4 4 0 00-3.8.6 6.52 6.52 0 00-6.77.29 6.83 6.83 0 00-3.44 4.12c-.61 2.26 0 5 2 8.35l.5.86L11.93 23l-1-1.73-4.31 2.45c-1.27-2.43-1.71-4.43-1.3-5.95a4.9 4.9 0 012.5-2.91 4.65 4.65 0 014.55-.41 1.63 1.63 0 00-.09.19 4 4 0 00.14 3.06 3.92 3.92 0 002 1.95 6.51 6.51 0 003.63 5.72 7.42 7.42 0 003.76 1.12 6.06 6.06 0 001.53-.2c2.26-.6 4.3-2.53 6.24-5.88l.5-.87z" }))));
}
exports.default = SvgFanFilled;
var templateObject_1;
//# sourceMappingURL=FanFilled.js.map